import cn from 'classnames';
import { useContext } from 'react';

import { BrandContext, HOME_CHEF, TEMPO } from 'context/BrandContext';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';

import DesktopFooter from './DesktopFooter';
import MobileFooter from './MobileFooter';

const FooterContainer = () => {
  const { brand } = useContext(BrandContext);
  const { isDesktop } = useScreenSizeConstants();

  const height = isDesktop ? '217px' : '75px';

  return (
    <div
      className={cn({
        'bg-cream-90': brand === HOME_CHEF,
        'bg-tempo-gray-100': brand === TEMPO,
      })}
      style={{ height }}
    >
      {isDesktop ? <DesktopFooter /> : <MobileFooter />}
    </div>
  );
};

export default FooterContainer;
